import { AU_STATES, AU_TIMEZONES, BILLING_FREQUENCIES } from '@pulsepoint/shared';
import { toOptions } from '../../components/form/FormSelect';

export const stateOptions = toOptions(AU_STATES);
export const timezoneOptions = toOptions(AU_TIMEZONES, (tz) => tz.replace('Australia/', ''));
export const frequencyOptions = toOptions(BILLING_FREQUENCIES);
